import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { businessHeaders } from '../../constants';

import useBusinessList from './hooks';
import styles from './BusinessList.module.scss';

function BusinessList({ businessReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useBusinessList();

  return (
    <div className={styles.gridContainer}>
      <DataGrid
        rows={businessReports}
        headers={businessHeaders}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
        fullWidth
        loading={loading}
      />
    </div>
  );
}

BusinessList.propTypes = {
  businessReports: PropTypes.arrayOf(
    PropTypes.shape({
      agencyName: PropTypes.string,
      aggregatorID: PropTypes.string,
      partnerName: PropTypes.string,
      totalTransactions: PropTypes.number,
      totalSuccess: PropTypes.number,
      totalErrors: PropTypes.number,
      totalPending: PropTypes.number,
    }),
  ),
  loading: PropTypes.bool,
};

BusinessList.defaultProps = {
  businessReports: [],
  loading: true,
};
export default BusinessList;
